/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";






const Goto = (props) => {
    const _VBID = (props.match.params.VBID !== undefined) ? props.match.params.VBID : null;
    console.log(_VBID)
    useEffect(() => {
        axios({
            method: 'post',
            url: "/api/v1/currentdate",
            headers: { 'referpage': '/vehicle/request' }
        })
        .then(
            result => {

                if (_VBID != null && _VBID != '') {
                    props.history.push({
                        pathname: '/vehicle/request',
                        state: {
                            VBID: _VBID
                        }
                    })
                }

            },
            error => {
                props.history.push({
                    pathname: '/auth/login-page',
                    state: {
                        redirect: '/vehicle/id/' + _VBID
                    }
                })
            }
        );  

       


    }, [])

    return (

        <div>

       
        </div>
    );

}





export default Goto;